import { openDB } from 'idb';
let dbPromise;
export function getDB() {
    if (!dbPromise) {
        dbPromise = openDB('salt-track', 2, {
            upgrade(db, oldVersion) {
                if (oldVersion < 1) {
                    db.createObjectStore('inventory', { keyPath: 'id' });
                    db.createObjectStore('refills', { keyPath: 'id' });
                }
                if (oldVersion < 2) {
                    db.createObjectStore('saltLevels', { keyPath: 'id' });
                }
            },
        });
    }
    return dbPromise;
}
